// map modules
import 'modules/ExtendLatlngByDistance';
import './busRoute/busRoute';
import './qr';
import './okinawaAds';
import './editTranslatedData';
import './mapGroupParticipants';
import './mapGroupParticipantsModal';
import './aliasMap';
import './spotFilter';
import './photoContest';

import { getCurrentPosition, watchPosition } from 'modules/GPS';
import { sleep } from 'modules/Utils';
import AnimationHelper from 'modules/AnimationHelper';
import { FacebookMl3AppShareLink } from 'modules/Native';
import { isMobile, isMl3App, isAndroid } from 'modules/DeviceOptions';


$(document).on('click', '.locationSelect', async e => {
  const mapPlugin = window[$(e.currentTarget).data('plugin')];
  const dataCheckMap = $('#CreateSpotModal').attr('dataCheckMap');
  if(isMobile && isMl3App && isAndroid){
    maplife.openMap('true');
  }
  if (mapPlugin.selectedPlaceObj == null) {
    if (!dataCheckMap) {
      try {
        const {
          coords: { latitude, longitude },
        } = await getCurrentPosition();

        mapPlugin.setCurrentLocation(latitude, longitude);
        mapPlugin.gmap.setZoom(16);
      } catch (error) {
        console.log(error);
      }

    } else {
      // mapPlugin.setCurrentLocation(mapPlugin.originalLatLng.lat(), mapPlugin.originalLatLng.lng());
      mapPlugin.gmap.setCenter(mapPlugin.originalLatLng);
      mapPlugin.gmap.setZoom(16);
    }
  } else {
    mapPlugin.gmap.setCenter(mapPlugin.selectedPlaceObj.latlng);
    mapPlugin.gmap.setZoom(16);
  }
});

$(document).on('click', '.mapControlCurrentLocation', async e => {
  const mapPlugin = window[$(e.currentTarget).data('plugin')];
  if (mapPlugin && mapPlugin.loaded === 2) {
    try {
      const {
        coords: { latitude, longitude },
      } = await getCurrentPosition();

      mapPlugin.setCurrentLocation(latitude, longitude);
      mapPlugin.gmap.setZoom(16);
    } catch (error) {
      // statements
      console.log(error);
      alert(window.resolveLang('位置情報取得を許可してください。'));
    }
  }
});

watchPosition(({ coords: { latitude, longitude } }) => {
  setLocation('MainMap', latitude, longitude);
  setLocation('ModalMap', latitude, longitude);
});

const setLocation = async (mapPluginName, latitude, longitude) => {
  while (
    !(
      window[mapPluginName] &&
      window[mapPluginName].gmap &&
      window[mapPluginName].loaded === 2
    )
  ) {
    await sleep(1000);
  }

  window[mapPluginName].setCurrentLocation(latitude, longitude, true);
};

const animationOptions = {
  visiblePercent: 10,
};
const animateArticleTemplateContainer = AnimationHelper(
  '#ArticleTemplateContainer > .articleCard',
  animationOptions
);
const animateCheckInTemplateContainer = AnimationHelper(
  '#CheckInTemplateContainer > .articleCard',
  animationOptions
);
window.animateMapWall = () => {
  animateArticleTemplateContainer();
  animateCheckInTemplateContainer();
};

// call FacebookMl3AppShareLink
$(document).on('click', '#shareFBLinkMap', function(e) {
  e.preventDefault();
  const dataShareLink = $(this).data('sharelink');
  FacebookMl3AppShareLink(dataShareLink);
});

// call FacebookMl3AppShareLink
$(document).on('click', '#shareFBLinkSNS', function(e) {
  e.preventDefault();
  const dataShareLink = $(this).data('sharelink');
  FacebookMl3AppShareLink(dataShareLink);
});